<template>
  <div class="live-control">
    <div class="live-control-bar">
      <a-button @click="startLive" type="danger" icon="play-circle">开播</a-button>
    </div>
    <j-modal
      :title="name"
      :visible.sync="visible"
      switchFullscreen
      :width="'600px'"
      @cancel="close()"
      :maskClosable="false"
      :destroyOnClose="true"
      onOk="handleOk"
      :footer="null"
    >
      <a-spin v-if="loading"></a-spin>
      <a-tabs v-show="!loading">
        <a-tab-pane tab="网页直播" key="1" forceRender>
          <a-button @click="txWebLiveStart" :disabled="!livePusherReady">开始直播</a-button>
          <a-button @click="txWebLiveStop" :disabled="!liveStatus">停止直播</a-button>
          <a-divider type="vertical"></a-divider>
          <a-radio-group buttonStyle="solid" v-model="source" @change="changeSource">
            <a-radio-button :value="0"> 关闭 </a-radio-button>
            <a-radio-button :value="1"> 摄像头 </a-radio-button>
            <a-radio-button :value="2"> 屏幕 </a-radio-button>
            <!-- <a-radio-button :value="3"> 混合 </a-radio-button> -->
          </a-radio-group>
          <div
            id="local_video"
            style="width: 100%; height: 500px; display: flex; align-items: center; justify-content: center"
          ></div>
        </a-tab-pane>
        <a-tab-pane tab="客户端直播(推荐)" key="2" forceRender>
          <div>
            <a-input addon-before="服务器" :value="pushUrl" style="width: 480px"></a-input>
            <a-button v-copy="pushUrl" type="primary">复制</a-button>
          </div>
          <br />
          <div>
            <a-input addon-before="Bearer令牌" :value="streamName" style="width: 480px"></a-input>
            <a-button v-copy="streamName" type="primary">复制</a-button>
          </div>
          <a-button @click="stopLive">停止直播</a-button>
          <a-divider>推流指引</a-divider>
          <div>
            <h3>{{ remark }}</h3>
          </div>
        </a-tab-pane>
      </a-tabs>
    </j-modal>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'

export default {
  name: 'LiveControlModal',
  data() {
    return {
      visible: false,
      loading: true,
      pullUrl: '',
      pushUrl: '',
      streamName: '',
      remark: '',
      liveStatus: false,
      livePusher: null,
      livePusherReady: false,
      source: 0,
    }
  },
  props: {
    id: {
      type: String,
      require: true,
    },
    name: {
      type: String,
      default: '直播助手',
    },
  },
  created() {},
  methods: {
    startLive() {
      this.visible = true
      getAction('/teaching/broadcast/beginLive?mediaId=' + this.id).then((res) => {
        if (res.success) {
          this.pushUrl = res.result.pushURL
          this.streamName = res.result.streamName
          this.remark = res.result.remark
          this.txWebLiveInit()
        }
        this.loading = false
      })
    },
    stopLive() {
      getAction('/teaching/broadcast/endLive?mediaId=' + this.id).then((res) => {
        if (res.success) {
          this.pushUrl = ''
          this.streamName = ''
          this.liveStatus = false
          this.txWebLiveStop()
          this.$message.success('下播成功')
        }
      })
    },
    changeSource(v) {
      console.log('切换源', this.source)
      // this.livePusher.pauseVideo()
      // this.livePusher.pauseAudio()
      this.livePusher.stopPush()
      switch (this.source) {
        case 0:
          this.livePusher.stopMicrophone()
          this.livePusher.stopScreenCapture()
          this.livePusher.stopCamera()
          break
        case 1:
          // this.livePusher.startMicrophone()
          this.livePusher.stopScreenCapture()
          this.livePusher.startCamera()
          break
        case 2:
          this.livePusher.stopCamera()
          this.livePusher.startMicrophone()
          this.livePusher.startScreenCapture()
          break
        case 3:
          // this.livePusher.startMicrophone()
          this.livePusher.startCamera()
          this.livePusher.startScreenCapture()
          break
      }
      // this.livePusher.resumeVideo()
      // this.livePusher.resumeAudio()
      this.livePusher.startPush(this.pushUrl)
    },
    txWebLiveInit() {
      this.webLiveCheck()
      let that = this
      this.livePusher = new TXLivePusher()
      this.livePusher.setRenderView('local_video')
      this.livePusher.videoView.muted = true
      // 设置视频质量
      this.livePusher.setVideoQuality('720p')
      // 设置音频质量
      this.livePusher.setAudioQuality('standard')
      // 自定义设置帧率
      this.livePusher.setProperty('setVideoFPS', 25)
      this.livePusher.setObserver({
        // 推流连接状态
        onPushStatusUpdate: function (status, message) {
          console.log(status, message)
        },
        // 推流统计数据
        onStatisticsUpdate: function (data) {
          console.log('video fps is ' + data.video.framesPerSecond)
        },
      })
      // 采集完摄像头和麦克风之后自动推流
      Promise.all([
        this.livePusher.startCamera(),
        this.livePusher.startMicrophone(),
        this.livePusher.startScreenCapture(),
      ]).then(function () {
        that.livePusherReady = true
      })
    },
    txWebLiveStart() {
      this.livePusher.startPush(this.pushUrl)
      this.liveStatus = true
    },
    txWebLiveStop() {
      if (this.livePusher) {
        this.livePusher.stopPush()
        this.livePusher.stopCamera()
        this.livePusher.stopMicrophone()
        this.livePusher.stopScreenCapture()
      }
    },
    webLiveCheck() {
      TXLivePusher.checkSupport().then(function (data) {
        // 是否支持WebRTC
        if (data.isWebRTCSupported) {
          console.log('WebRTC Support')
        } else {
          this.$message.error('浏览器不支持WebRTC')
        }
        // 是否支持H264编码
        if (data.isH264EncodeSupported) {
          console.log('H264 Encode Support')
        } else {
          this.$message.error('浏览器不支持H264编码')
        }
      })
    },
    close() {
      this.visible = false
    },
  },
}
</script>

<style lang="less" scoped>
.live-control {
  min-width: 200px;
  display: inline-block;
}
.live-control-bar {
}
</style>